import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation} from '@github-ui/react-query'
import {useReviewSummariesActions, usePullRequestBasePath} from '../stores/selectors'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {setReviewSummaryQueryData} from '../page-data/loaders/use-conversation-comments'
import type {ReactToIssueCommentResponse, ReactToIssueCommentVariables} from './use-react-to-issue-comment-mutation'

// eslint-disable-next-line no-barrel-files/no-barrel-files
export {applyVariablesToReactions} from './use-react-to-issue-comment-mutation'

// Types for issue comment vs review summary reactions are kept in sync to allow for easier code reuse
type ReactToReviewSummaryVariables = ReactToIssueCommentVariables

type ReactToReviewSummaryResponse = ReactToIssueCommentResponse

export function useReactToReviewSummaryMutation() {
  const basePath = usePullRequestBasePath()
  const {updateReviewSummary} = useReviewSummariesActions()

  return useMutation({
    mutationFn: async ({commentId, reaction, viewerHasReacted}: ReactToReviewSummaryVariables) => {
      const apiUrl = `${basePath}/page_data/${
        viewerHasReacted ? PageData.removeCommentReaction : PageData.addCommentReaction
      }`

      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          reaction,
          reviewSummaryCommentId: commentId,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json as ReactToReviewSummaryResponse
    },
    onSuccess: (data, variables, _onMutateResult, context) => {
      if (isFeatureEnabled('prs_new_conversation_comments_api')) {
        setReviewSummaryQueryData(context.client, basePath, parseInt(variables.commentId, 10), comment => {
          comment.reactionGroups = data.reactionGroups
        })
      } else {
        updateReviewSummary({
          match: storedSummary => storedSummary.id === variables.commentId,
          transform: oldSummary => {
            if (oldSummary) {
              return {...oldSummary, reactionGroups: data.reactionGroups}
            }
          },
        })
      }
    },
  })
}
